import { Component, input } from '@angular/core';

@Component({
    selector: 'ap-submit-text',
    templateUrl: 'submit.component.html',
    styleUrls: ['./submit.component.scss']
})
export class ApSubmitTextComponent {
    /**
     * Required - Button text when `isLoading` is `false`
     */
    public readonly submitText = input.required<string>();

    /**
     * Required - Button text when `isLoading` is `true`
     */
    public readonly loadingText = input.required<string>();

    /**
     * State of button
     * Defaults to `false`
     */
    public readonly isLoading = input(false);
}
